"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lib = require("../../mqttclient/lib");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Pusher = function () {
  function Pusher() {
    var _this = this;

    _classCallCheck(this, Pusher);

    this.onSubscribe = function (err, res) {
      if (err) {
        console.error("Error subscribing " + res.data.topic + " topic " + err);
      } else {
        console.log("Successfully subscribed topic " + res.data.topic + " with grantedQOS " + res.data.grantedQos[0]);
      }
    };

    this.onMqttConnectionStatusChange = function (options) {
      if (options.status === "online") {
        if (_this.user && _this.user.online_packet) {
          var onlinePacket = _this.user.online_packet;
          onlinePacket.payload = JSON.stringify(onlinePacket.payload);
          _lib2.default.publish(onlinePacket);
        }
      }
    };

    this.mqtt_qos = 1;
    this.user = null;
  }

  _createClass(Pusher, [{
    key: "connect",
    value: function connect(userObj, messageReceiver) {
      var self = this;
      return new Promise(function (resolve, reject) {
        self.user = userObj;
        var clientId = "$cid::" + userObj.id + "$r::" + Math.floor(Math.random() * 1000 + 1);
        var willData = userObj.offline_packet;
        var conOpts = { clientId: clientId, port: userObj.mqtt.port, host: userObj.mqtt.host, autoConnect: true, willData: willData };

        var callback = function callback(err, data) {
          if (err) {
            console.error('Error while connecting to Mqtt ', err);
            reject({ status: "failed", message: "Unable to connect to remote messaging service" });
          }
          if (data.status === 'success') {
            console.log('successfully connected to client id ', clientId);
            userObj.topics.map(function (topicObjec) {
              _lib2.default.subscribe({ topic: topicObjec.topic, qos: topicObjec.qos, callback: messageReceiver }, self.onSubscribe);
            });

            _lib2.default.addConnectionStatusChangeCallback(self.onMqttConnectionStatusChange);
            resolve({ status: "success", message: "successfully connected to remote messaging service" });
          }
          if (data.data === 'connecting') {
            setTimeout(function () {
              _lib2.default.connect(conOpts, callback);
            }, 1000);
          }
        };

        _lib2.default.connect(conOpts, callback);
      });
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      _lib2.default.disconnect();
    }
  }, {
    key: "publish",
    value: function publish(topic, message) {
      var packet = {
        topic: topic,
        payload: message,
        qos: this.mqtt_qos
      };
      _lib2.default.publish(packet);
    }
  }]);

  return Pusher;
}();

exports.default = new Pusher();


// WEBPACK FOOTER //
// ../pusher/lib/pusher.js